import {useCallback, useState} from 'react'
import {ExportJob} from '@/features/exports/types'
import {downloadExportJob} from '@/features/exports/utils/download'
import {errorHandler} from '@/utilities/helpers'

/**
 * Download a ready export job, tracking which job is currently downloading so the
 * triggering row can show progress. Backend rejections (not ready / not found) are
 * surfaced as toasts via the shared error handler (FR-020).
 */
export const useDownloadExport = () => {
    const [downloadingId, setDownloadingId] = useState<string | null>(null)

    const download = useCallback(async (job: ExportJob) => {
        try {
            setDownloadingId(job.id)
            await downloadExportJob(job)
        } catch (error) {
            errorHandler(error)
        } finally {
            setDownloadingId(null)
        }
    }, [])

    return {download, downloadingId}
}
